<div *ngIf="!isViewResult">
  <div class="row">
    <div class="col-lg-6">
      <label>{{idx+1}}. {{ question.content }}</label>
      <!--slider-->
      <nouislider *ngIf="question.note != 'other'"
                  name="number-slider"
                  [step]="1"
                  [config]="sliderConfig"
                  [(ngModel)]="sliderRange" (ngModelChange)="changeSlider($event, question)"></nouislider>
      <!--slider-->
    </div>
    <div *ngIf="higher8Years && question.note != 'other'" class="col-lg-4">
      <label style="color: #999; margin-top: 35px;">{{'36YearsOrMore' | translate}}</label>
    </div>
    <div *ngIf="!higher8Years && question.note != 'other' && question.note !== 'years'" class="col-lg-4">
      <label style="color: #999; margin-top: 35px;">{{ 'finalization.months' | translate }}</label>
    </div>
    <div *ngIf="!higher8Years && question.note === 'years'" class="col-lg-4">
      <label style="color: #999; margin-top: 35px;">{{ 'finalization.years' | translate }}</label>
    </div>
  </div>
  <p *ngIf="question.note != 'other'">{{'controlPanel.criteria.inputLower' | translate : {min: minLimit, max: maxLimit} }}</p>
  <p *ngIf="question.note != 'other' && question.note != 'months'">{{'controlPanel.criteria.monthYearText' | translate}}</p>
  <div class="row form-inline">
    <div class="col-lg-12">
      <p *ngIf="question.note == 'other'"><span>{{ 'controlPanel.criteria.answerCurrentRange' | translate }} <b>{{minLimit}}</b> {{question.options[0].content}} {{'common.and' | translate}}
                                                                                  <b>{{maxLimit}}</b> {{question.options[0].content}}. </span>
        {{'controlPanel.criteria.noteOther' | translate}}</p>
      <span>{{'controlPanel.criteria.minLimit' | translate}}</span>
      <input type="number"
             name="minValue"
             class="form-control mx-2"
             min="0"
             [disabled]="statistic"
             [(ngModel)]="minLimit">
      <span *ngIf="question.note == 'monthYears'">({{minLimit | monthsToYears}})</span>
      <span *ngIf="question.note == 'years' || question.note == 'months'" class="text-lowercase"> {{formatInputText}}</span>
      <span *ngIf="question.note == 'other'" class="text-lowercase"> {{question.options[0].content}}.</span>
      <span >{{'controlPanel.criteria.maxLimit' | translate}}</span>
      <input type="number"
             name="maxValue"
             min="0"
             [disabled]="statistic"
             class="form-control mx-2"
             [(ngModel)]="maxLimit">
      <span *ngIf="question.note == 'monthYears'">({{maxLimit | monthsToYears}}).</span>
      <span *ngIf="question.note == 'years' || question.note == 'months'" class="text-lowercase"> {{formatInputText}}.</span>
      <span *ngIf="question.note == 'other'" class="text-lowercase"> {{question.options[0].content}}.</span>
    </div>
  </div>
  <p><span>{{numberApp || numberApp == 0 ? numberApp : totalApp}}</span> {{'controlPanel.criteria.applicants' | translate}}</p>
  <div class="form-inline" *ngIf="!statistic">
    <span>{{'controlPanel.criteria.assign' | translate}}</span>
    <input type="number"
           name="score"
           class="form-control mx-2"
           min="0"
           max="99"
           [disabled]="statistic"
           [(ngModel)]="score">
  </div>
  <div style="margin-top: 10px;">
    <button class="btn btn-success" *ngIf="!statistic" (click)="onGetAllResult()">{{'common.update' | translate}}</button>
  </div>
</div>
<div *ngIf="isViewResult">
  <div class="row">
    <div class="col-lg-8">
      <label>{{idx+1}}. {{ question.content }}</label>
      <div style="margin-top: 50px;" *ngIf="question.note !== 'other'">
        <p>{{'controlPanel.numberQuestion.lowestAnswer' | translate : {answerLowest: answerLowest, answerMinYear: answerMinYear, answerMinMonth: answerMinMonth, answerHighest: answerHighest, answerMaxYear: answerMaxYear, answerMaxMonth: answerMaxMonth} }}</p>
        <b>{{'controlPanel.numberQuestion.limitSelected' | translate }}</b> {{'controlPanel.numberQuestion.lowerLimit' | translate }} <b>{{sliderRange[0]}}</b> {{'controlPanel.numberQuestion.months' | translate }} ({{minYear}} {{'controlPanel.numberQuestion.years' | translate }} {{minMonth}} {{'controlPanel.numberQuestion.months' | translate }}). {{'controlPanel.numberQuestion.upperLimit' | translate }} <b>{{sliderRange[1]}}</b> {{'controlPanel.numberQuestion.months' | translate }} ({{maxYear}} {{'controlPanel.numberQuestion.years' | translate }} {{maxMonth}} {{'controlPanel.numberQuestion.months' | translate }}).
      </div>
      <div style="margin-top: 50px;" *ngIf="question.note === 'other'">
        <p>{{'controlPanel.numberQuestion.lowestAnswerOther' | translate : {lowest: lowest, question: question, highest: highest} }}</p>
        <b>{{'controlPanel.numberQuestion.limitSelected' | translate }}<</b> {{'controlPanel.numberQuestion.lowerLimit' | translate }} <b>{{sliderRange[0]}}</b> {{question.options[0].content}}. {{'controlPanel.numberQuestion.upperLimit' | translate }} <b>{{sliderRange[1]}}</b> {{question.options[0].content}}.
      </div>
    </div>
  </div>
  <p><span>{{applicantsFulfill}}</span> {{'controlPanel.applicantFulfilled' | translate }} <b>{{score}}</b></p>
</div>
<hr>
